// datatable related plugins
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import AutoReloadList from "components/shared-components/AutoReload/AutoReloadList";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { getResourceIdXML } from "helpers/form_helper";
import { getFileNameExcel } from "helpers/utils";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  downloadXmlErrorInvoices,
  errorInvoicesDelete,
  exportInvoice,
  getListErrorInvoices,
  releaseErrorInvoices,
  resetBackupDataNew,
  resetdownloadPDFInvoices,
  resetDownloadXmlErrorInvoices,
  resetEditErrorInvoices,
  resetErrorInvoicesDelete,
  resetExportInvoice,
  resetListErrorInvoices,
  resetPreviewPdfErrorInvoice,
  resetReleaseErrorInvoices,
  resetSetBuStoreHeader,
  setColumnVisibleRegistryInvoices,
  setMethodSign,
} from "store/actions";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
} from "store/auth/login/actionTypes";
import {
  SET_BU_STORE_HEADER,
  SET_BU_STORE_HEADER_SUCCESS,
} from "store/dashboard/actionTypes";
import {
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
} from "store/data-format/actionTypes";
import {
  DOWNLOAD_XML_ERROR_INVOICES_FAIL,
  DOWNLOAD_XML_ERROR_INVOICES_SUCCESS,
  ERROR_INVOICES_DELETE_FAIL,
  ERROR_INVOICES_DELETE_SUCCESS,
  PREVIEW_PDF_ERROR_INVOICE_FAIL,
  PREVIEW_PDF_ERROR_INVOICE_SUCCESS,
} from "store/error-invoices/actionTypes";
import {
  EXPORT_INVOICE_FAIL,
  EXPORT_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import DetailDataModal from "./DetailDataModal";
import { getStatus } from "./helper/functionHelper";
import ListHDonModal from "./ListHDonModal";
import HistoryTransferModal from "./modal/HistoryTransferModal";
import PDFViewModal from "./modal/PDFViewDownloadModal";
import SignHSMModal from "./modal/SignHSMModal";
import TypeSignDigitalModal from "./modal/TypeSignDigitalModal";
import VerifyPinUSBModal from "./modal/VerifyPinUSBModal";
import { MODE, tableFormateDate } from "./utils";

const ListData = props => {
  const { addToast } = useToasts();
  const history = useHistory();
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  const [idHistory, setIdHistory] = useState(null);
  // Modal detail
  const [detailData, setDetailData] = useState(null);
  const [modalDetailData, setModalDetailData] = useState(false);
  const toggleDetailDataModal = () => setModalDetailData(!modalDetailData);
  // Modal listHDOn
  const [dataListHDon, setDataListHDon] = useState(null);
  const [modalListHDon, setModalListHDon] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const toggleListHDonModal = () => setModalListHDon(!modalListHDon);

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  // store reducer
  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    fileDownload,
    fileDownloadName,
    type,
    previewPdfErrorFile,
    edit: errorInvoicesEdit,
    errorInvoicesDeleteData,
  } = errorInvoices;
  const { loading, listData, totalCount, columnsVisible, params } =
    errorInvoices.notificationErrorInvoices;

  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    exportInvoiceData,
    type: typeIssueInvoice,
    fileDownload: fileDownloadIssueInvoice,
    fileDownloadName: fileDownloadNameIssueInvoice,
    bkDataNew,
  } = issueInvoice;

  const dataFormat = useSelector(state => state.dataFormat);
  const {
    previewPdfRegisterFile,
    type: typePDF,
    fileDownload: fileDownloadPDF,
    fileDownloadName: fileDownloadNamePDF,
  } = dataFormat;
  const { t, i18n } = useTranslation(["errorInvoice"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));
  const [dataViewDocument, setDataViewDocument] = useState(null);
  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    switch (typeIssueInvoice) {
      case EXPORT_INVOICE_SUCCESS: {
        if (fileDownloadIssueInvoice !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadIssueInvoice;
          link.setAttribute("download", fileDownloadNameIssueInvoice);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      }
      case EXPORT_INVOICE_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetExportInvoice());
        break;
      default:
        break;
    }
  }, [typeIssueInvoice]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);

  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);

  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);

  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);

  const Dashboard = useSelector(state => state.Dashboard);

  const { tenantCodeHeader, type: typeDashboard, buStoreHeader } = Dashboard;

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_XML_ERROR_INVOICES_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      }
      case DOWNLOAD_XML_ERROR_INVOICES_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlErrorInvoices());
        break;
      case PREVIEW_PDF_ERROR_INVOICE_SUCCESS: {
        if (!modalPdfView) {
          if (previewPdfErrorFile !== null) {
            const link = document.createElement("a");
            link.href = previewPdfErrorFile.data;
            link.setAttribute("download", "error-invoice.pdf");
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      }
      case PREVIEW_PDF_ERROR_INVOICE_FAIL:
        if (!modalPdfView) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetPreviewPdfErrorInvoice());
        }
        break;
      case ERROR_INVOICES_DELETE_SUCCESS: {
        addToast("Xóa thông báo thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        dispatch(getListErrorInvoices(params));
        dispatch(resetErrorInvoicesDelete());
        break;
      }
      case ERROR_INVOICES_DELETE_FAIL:
        addToast("Xóa thông báo thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetErrorInvoicesDelete());
        break;
      default:
        break;
    }
  }, [type]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesEdit && errorInvoicesEdit.success) {
      addToast(
        t("message.update", {
          target: t("error_invoice"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      dispatch(resetEditErrorInvoices());
      dispatch(getListErrorInvoices(params));
      toggleDetailDataModal();
    }
  }, [errorInvoicesEdit]);

  const [isCheckChangeStore, setIsCheckChangeStore] = useState(false);
  useEffect(() => {
    if (typeDashboard === SET_BU_STORE_HEADER) {
      setIsCheckChangeStore(true);
    }
    if (typeDashboard === SET_BU_STORE_HEADER_SUCCESS && isCheckChangeStore) {
      params.page = 1;
      dispatch(getListErrorInvoices(params));
      dispatch(resetSetBuStoreHeader());
    }
  }, [typeDashboard]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);

  useEffect(() => {
    initColumn();
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
    }
    return () => {
      dispatch(resetListErrorInvoices());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDetailData({ ...row, mode: MODE.VIEW });
      toggleDetailDataModal();
      //   setDataDetail({
      //     content: row.content,
      //     file_name: row.file_name,
      //     process_upload_id: row.id,
      //     status: row.status,
      //   });
      //   setDataDetail({ id: row.id, mode: MODE_FORM.VIEW });
      //   toggleViewDetailModal();
    },
  };
  const showPdfById = row => {
    let path = "";
    if (row.auth_status === AUTH_STATUS_APPROVE) {
      path = "approve-pdf";
    } else {
      path = "review-pdf";
    }
    setDataViewDocument({
      id: row.id,
      path,
    });
    togglePdfViewModal();
  };
  const listRowAction = [
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa",
      conditionVisible: {
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setDataViewDocument({
          id: row.id,
        });
        toggleConfirmDeleteModal();
      },
    },
    {
      icon: <i className="bx bx-send font-size-18 text-success" />,
      text: "Gửi duyệt thông báo",
      conditionVisible: {
        resource_id: [],
        auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
      },
      onClick: row => {
        dispatch(setMethodSign(row.bu_code, row.bu_code));
        // if (toastWarningIsAllStore(addToast)) {
        //   return;
        // }
        setTransferData({
          id: row.id,
          mst: row.mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.HDSS,
        });
        toggleTypeSignModal();
      },
    },
    {
      icon: <i className="bx bx-download font-size-18 text-primary" />,
      text: "Download XML",
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type);
        if (resource_id) {
          dispatch(downloadXmlErrorInvoices(resource_id, row.ten));
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    {
      icon: <i className="bx bx-history font-size-18 text-success" />,
      text: "Lịch sử truyền nhận",
      onClick: row => {
        setIdHistory(row.id);
        toggleHistoryTransferModal();
      },
    },
    // {
    //   icon: <i className="bx bx-edit font-size-18 text-success" />,
    //   text: "Cập nhật",
    //   conditionVisible: {
    //     auth_status: [AUTH_STATUS_NEW],
    //   },
    //   onClick: row => {},
    // },

    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật thông báo",
      conditionVisible: {
        auth_status: [AUTH_STATUS_NEW],
      },
      onClick: row => {
        setDetailData({ ...row, mode: MODE.EDIT });
        toggleDetailDataModal();
      },
    },
    {
      icon: <i className="bx bxs-file-pdf font-size-18 text-danger" />,
      text: "Xem trước bản hiển thị",
      onClick: row => {
        showPdfById(row);
      },
    },
  ];

  const selectFilterLoai = {
    1: "Thông báo hủy/giải trình của NNT",
    2: "Thông báo hủy/giải trình của NNT theo thông báo của CQT",
  };

  const getAuthStatus = (status, id) => {
    let infoError = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const LADHDDT_LABEL = {
    1: "HĐĐT theo Nghị định 123/2020/NĐ-CP ( Thông tư 78 )",
    2: "HĐĐT theo Quyết định số 1209/QĐ-BTC ( Thông tư 32 có mã xác thực CQT )",
    3: "HĐĐT theo Nghị định số 51/2010/NĐ-CP ( Thông tư 32 )",
    4: "Hoá đơn đặt in",
  };

  const initColumns = [
    {
      dataField: "id",
      text: "id",
      sort: true,
      hidden: env.API_AIR_BRAKE_ENV !== "dev",
    },
    {
      dataField: "bu_code",
      text: "Mã đơn vị",
      sort: true,
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
    },
    // {
    //   dataField: "pban",
    //   text: t("field.pban"),
    //   hidden: false,
    //   filter: textFilter({
    //     placeholder: "Nhập",
    //   }),
    // },
    {
      dataField: "dshdon",
      text: "Danh sách hóa đơn",
      hidden: false,
      formatter: (cellContent, row) => {
        if (cellContent.length > 1) {
          return (
            <div
              style={{ cursor: "pointer" }}
              className="text-center text-info"
              onClick={() => {
                setDataListHDon({ row: row, cellContent: cellContent });
                toggleListHDonModal();
              }}
            >
              Hiển thị danh sách
            </div>
          );
        } else if (cellContent.length === 1) {
          let item = cellContent[0];
          let KHHDON = "Ký hiệu HĐ: " + item.KHMSHDon + item.KHHDon;
          let SHDon = "Số HĐ " + item.SHDon;
          return (
            <div
              style={{ cursor: "pointer" }}
              className="text-left text-info"
              onClick={() => {
                setDataListHDon({ row: row, cellContent: cellContent });
                toggleListHDonModal();
              }}
            >
              <div>{SHDon}</div>
              <div>{KHHDON}</div>
            </div>
          );
        }
      },
    },
    {
      dataField: "ten",
      text: "Tên",
      hidden: false,
      formatter: (cellContent, row) => (
        <div style={{ width: "200px", whiteSpace: "initial" }}>{row.ten}</div>
      ),
      //   filter: textFilter({
      //     placeholder: "Nhập",
      //   }),
    },
    {
      dataField: "auth_status",
      text: "Trạng thái",
      hidden: false,
      formatter: (cellContent, row) => getAuthStatus(row.auth_status, row.id),
      filter: selectFilter({
        placeholder: "Chọn",
        options: selectFilterAuthStatus,
      }),
    },
    {
      dataField: "mso",
      text: "Mẫu số thông báo",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "ntbao",
      text: "Ngày thông báo",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.ntbao),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
    {
      dataField: "ladhddt",
      text: "Loại hóa đơn",
      hidden: false,
      formatter: (cellContent, row) => {
        return LADHDDT_LABEL[row.ladhddt];
      },
      filter: selectFilter({
        placeholder: "Chọn",
        options: LADHDDT_LABEL,
      }),
    },
    {
      dataField: "loai",
      text: "Loại thông báo",
      hidden: false,
      formatter: (cellContent, row) => {
        let text = "";
        switch (cellContent) {
          case 1:
            text = "Thông báo hủy/giải trình của NNT";
            break;
          case 2:
            text = "Thông báo hủy/giải trình của NNT theo thông báo của CQT";
            break;
          default:
            break;
        }
        return text;
      },
      filter: selectFilter({
        placeholder: "Chọn",
        options: selectFilterLoai,
      }),
    },
    {
      dataField: "tnnt",
      text: "Tên người nộp thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "mst",
      text: "MST",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "tcqt",
      text: "Tên cơ quan thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
    {
      dataField: "mcqt",
      text: "Mã cơ quan thuế",
      hidden: false,
      filter: textFilter({
        placeholder: "Nhập",
      }),
    },
  ];

  const listMultipleRowAction = [
    {
      icon: <i className="far fa-file-excel font-size-18 text-success" />,
      text: "Xuất danh sách hóa đơn sai sót",
      isLoading: exportInvoiceData.loading,
      loadingText: "Đang xuất danh sách hóa đơn sai sót",
      onClick: data => {
        let objectExport = exportFormatData();
        objectExport = {
          ...objectExport,
          ...params.columnFilter,
          sort: params.sort ? params.sort : "-checker_date",
          keywords: params.keywords,
        };
        dispatch(
          exportInvoice(
            objectExport,
            getFileNameExcel("DanhSachHoaDonSaiSot"),
            "invoice-errors"
          )
        );
      },
    },
  ];

  const formatDataHandle = (objectExport, dataField) => {
    switch (dataField) {
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][label]`] = "Số HĐ";
        break;
      case "ttchung_khhdon":
        objectExport[`columns[${dataField}][label]`] = "Ký hiệu HĐ";
        break;
      case "ttchung_nlap":
        objectExport[`columns[${dataField}][label]`] = "Ngày lập";
        break;
      case "mcqtcap":
        objectExport[`columns[${dataField}][label]`] = "Mã CQT cấp";
        break;
      case "ldo":
        objectExport[`columns[${dataField}][label]`] = "Lí do";
        break;
      case "auth_status":
        for (const key in selectFilterAuthStatus) {
          objectExport[`columns[${dataField}][mapping][${key}]`] =
            selectFilterAuthStatus[key];
        }
        break;
      case "ttchung_khmshdon":
        objectExport[`columns[${dataField}][mapping][1]`] = "HÓA ĐƠN GTGT";
        objectExport[`columns[${dataField}][mapping][2]`] = "HÓA ĐƠN BH";
        break;
      case "ttchung_shdon":
        objectExport[`columns[${dataField}][mapping][null]`] = "Chờ cấp số";
        break;
      case "ntbao":
        objectExport[`columns[${dataField}][type]`] = "date";
        break;
      default:
        break;
    }
    // Format style
    switch (dataField) {
      case "nmua_ten":
        objectExport[
          `columns[${dataField}][contentOptions][alignment][wrapText]`
        ] = true;
        objectExport[`columns[${dataField}][dimensionOptions][width]`] = 80;
        break;
      default:
        objectExport[
          `columns[${dataField}][dimensionOptions][autoSize]`
        ] = true;
        break;
    }
  };

  const exportFormatData = () => {
    let objectExport = {};
    columns
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        if (formatData.dataField === "dshdon") {
          let expandFields = [
            "ttchung_shdon",
            "ttchung_khhdon",
            "ttchung_nlap",
            "mcqtcap",
            "ldo",
          ];
          for (const item of expandFields) {
            formatDataHandle(objectExport, item);
          }
        } else {
          formatDataHandle(objectExport, formatData.dataField);
          const value = formatData.text;
          objectExport[key] = value;
        }
        return formatData;
      });
    return objectExport;
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListErrorInvoices(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListErrorInvoices(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleRegistryInvoices(field, value));
  };
  useEffect(() => {
    switch (typePDF) {
      case DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS: {
        if (fileDownloadPDF !== null) {
          const link = document.createElement("a");
          link.href = fileDownloadPDF;
          link.setAttribute(
            "download",
            fileDownloadNamePDF || "Error-invoice.pdf"
          );
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
        break;
      }
      case DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL: {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetdownloadPDFInvoices());
      }
      default:
        break;
    }
  }, [typePDF]);
  return (
    <React.Fragment>
      <AutoReloadList
        listData={listData}
        dataCheck={bkDataNew}
        actionReset={() => {
          dispatch(resetBackupDataNew());
        }}
        actionReload={() => {
          dispatch(getListErrorInvoices(params, false));
        }}
      />
      {/* delete modal */}
      <ConfirmModal
        isOpen={modalConfirmDelete}
        titleHeader={"Xác nhận xóa thông báo"}
        titleBody={"Hệ thống sẽ thực hiện xóa thông báo này ?"}
        isDisableButton={errorInvoicesDeleteData.loading}
        onConfirm={note => {
          dispatch(errorInvoicesDelete(dataViewDocument.id));
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleConfirmDeleteModal}
      />
      {/* Hình thức ký modal */}
      <TypeSignDigitalModal
        t={t}
        isOpen={modalTypeSign}
        downloadXmlFunc={downloadXmlErrorInvoices}
        transferData={transferData}
        toggle={toggleTypeSignModal}
        toggleUSBSignModal={toggleUSBSignModal}
        toggleHSMSignModal={toggleHSMSignModal}
      />
      {/* Ký USB Modal */}
      <VerifyPinUSBModal
        t={t}
        isOpen={modalUSBSign}
        transferData={transferData}
        resetDataFunc={getListErrorInvoices}
        params={params}
        toggle={toggleUSBSignModal}
      />
      {/* Ký HSM Modal */}
      <SignHSMModal
        t={t}
        isOpen={modalHSMSign}
        transferData={transferData}
        resetDataFunc={getListErrorInvoices}
        releaseFunc={releaseErrorInvoices}
        resetReleaseFunc={resetReleaseErrorInvoices}
        params={params}
        toggle={toggleHSMSignModal}
      />
      {/* ErrorReleaseModal */}
      <ErrorReleaseModal
        isOpen={modalErrorRelease}
        toggle={toggleErrorReleaseModal}
        id={idRelease}
        path={"invoice-errors"}
      />
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
      ></PDFViewModal>
      <HistoryTransferModal
        isOpen={modalHistoryTransfer}
        toggle={toggleHistoryTransferModal}
        id={idHistory}
        path={"invoice-errors"}
      />
      <ListHDonModal
        dataListHDon={dataListHDon}
        isOpen={modalListHDon}
        toggle={toggleListHDonModal}
      />
      <DetailDataModal
        detailData={detailData}
        isOpen={modalDetailData}
        toggle={toggleDetailDataModal}
      />
      <div className="page-content">
        <MetaTags>
          <title>Danh sách hóa đơn sai sót</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={`Danh sách hóa đơn sai sót (${totalCount})`}
            breadcrumbItems={[
              { name: "Thông báo Hóa đơn sai sót" },
              { name: "Danh sách hóa đơn sai sót" },
            ]}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listMultipleRowAction={listMultipleRowAction}
                      listRowAction={
                        isRoleStore
                          ? listRowAction.filter(
                              item => item.text !== "Gửi duyệt thông báo"
                            )
                          : listRowAction
                      }
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          history.push("/error-invoices/create");
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
